import Fetch from 'utils/fetch';
import { settings } from 'settings';
import { Dayjs } from 'dayjs';
import { OrdersEtaMetrics } from './ordersEtaTypes';

export async function fetchOrderEtaMetrics(
  date: Dayjs
): Promise<OrdersEtaMetrics> {
  const dateStr = date.format('YYYY-MM-DD');
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/order/eta-metrics?date=${dateStr}`,
  });

  if (response.ok) {
    return (await response.json()) as OrdersEtaMetrics;
  } else {
    return {
      date: dateStr,
      ordersDelivered: 0,
      ordersDeliveredInWindow: 0,
      ordersCloseToEtaRelativeToPickup: 0,
      ordersCloseToEta: 0,
      pickupTooEarly: 0,
      pickupTooLate: 0,
      deliveryTooEarly: 0,
      deliveryTooLate: 0,
      ordersWithEta: 0,
      etaDeviationMinutes: {
        count: 0,
        average: 0,
        minimum: 0,
        maximum: 0,
        stdDev: 0,
      },
      etaRanges: [],
    };
  }
}
